import React from 'react'
import {GatsbyImage, getImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const DoubleImage = ({leftImage, rightImage, leftImageCaption, rightImageCaption, leftVideo, rightVideo, removePadding = false}) => {

  return (
    <>
      <section className={`double-image${removePadding ? ' double-image--no-padding' : ''}`}>
        <div className="double-image__inner">
          <div className="double-image__item">
            <Fade distance='40px' bottom>
              <React.Fragment>
                {leftVideo && <video autoPlay loop muted playsInline src={leftVideo} />}
                {leftImage?.localFile.childImageSharp && !leftVideo && <GatsbyImage image={getImage(leftImage.localFile)} alt={leftImage.altText}/>}
                {!leftImage?.localFile.childImageSharp && !leftVideo && <img src={leftImage.localFile.publicURL} alt={leftImage.altText} />}
                {leftImageCaption && 
                  <div className="double-image__cap">
                    {parse(leftImageCaption)}
                  </div>
                }
              </React.Fragment>
            </Fade>
          </div>

          <div className="double-image__item">
            <Fade distance='40px' bottom>
              <React.Fragment>
                {rightVideo && <video autoPlay loop muted playsInline src={rightVideo} />}
                {rightImage?.localFile.childImageSharp && !rightVideo && <GatsbyImage image={getImage(rightImage.localFile)} alt={rightImage.altText}/>}
                {!rightImage?.localFile.childImageSharp && !rightVideo && <img src={rightImage.localFile.publicURL} alt={leftImage.altText} />}
                {rightImageCaption && 
                  <div className="double-image__cap">
                    {parse(rightImageCaption)}
                  </div>
                }
              </React.Fragment>
            </Fade>
          </div>
        </div>
      </section>
    </>
  );
};

export default DoubleImage
